import { TEAMS_COLLECTION, INVITES_COLLECTION } from '../../../constants'
import { FirestoreClient, Invite } from '../../../types'
import firebase from 'firebase'
import { FirestoreAdmin } from '../../../types/FirestoreAdmin'

interface Props<T extends FirestoreClient | FirestoreAdmin> {
  firestore: T
  teamId: string
}

export const getInvitesRef = <T extends FirestoreClient | FirestoreAdmin>({
  firestore,
  teamId,
}: Props<T>): T extends FirestoreClient
  ? firebase.firestore.CollectionReference<Invite>
  : FirebaseFirestore.CollectionReference => {
  return firestore
    .collection(TEAMS_COLLECTION)
    .doc(teamId)
    .collection(INVITES_COLLECTION) as any
}
